export interface ConfirmChangesDialogData {
	dialogTitle: string;
	heading: string;
	fields: ConfirmChangeFieldData[];
}

export interface ConfirmChangeFieldData {
	isChanged: boolean;
	label: string;
	value: string;
}

export enum ConfirmChangeActionType {
	Create = "Create",
	Update = "Update",
}
